import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { TimeBudgetView } from '../../models/timebudgetView';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionSelectors } from '@store';
import { IndexCard } from '../../../auth/store/models';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-statistik-sag',
    template: `<app-statistik-sag-ui
        [timebudgets]="timebudgets$ | async"
        [userCards]="userCards$ | async"
        [medID]="medID"
        [month]="month"
        [year]="year"
        (reloadTimebudget)="reload()"
    ></app-statistik-sag-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikModalSagContainer implements OnInit {
    @Input() kundeID: number;
    @Input() medID: number;
    @Input() month: number;
    @Input() year: number;

    private reloadTrigger$ = new BehaviorSubject<void>(null);

    date: Date;

    timebudgets$: Observable<TimeBudgetView[]>;
    userCards$: Observable<IndexCard[]>;

    constructor(
        private statistikService: StatistikService,
        private sessionSelector: SessionSelectors,
    ) { }

    ngOnInit(): void {
        this.date = this.convertYearMonthToDate(this.year, this.month);
        this.timebudgets$ = this.reloadTrigger$.pipe(
            switchMap(() => {
                if (this.medID) {
                    return this.statistikService.getTimebudgetByMedIdAndKundeId(this.year, this.month, this.medID, this.kundeID);
                } else {
                    return this.statistikService.getTimebudgetByKundeId(this.year, this.month, this.kundeID);
                }
            })
        );
        this.userCards$ = this.sessionSelector.allUsers$;
    }

    reload() {
        this.reloadTrigger$.next();
    }

    convertYearMonthToDate(year: number, month: number): Date {
        const date = new Date();
        date.setFullYear(year, month - 1, 1);
        return date;
    }
}
